import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  TextField,
  Box,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useAuth } from "../../Context/AuthContext";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_REST_URL;



const style = {
  position: "absolute",
  top: "52%",
  // left: "50%",
  right: "380px",
  transform: "translate(90%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

function AddRevenueDialog({
  isRevenueDialogOpen,
  handleCloseRevenueDialog,
  clientList,
  selectedId,
}) {
  const { token } = useAuth();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  useEffect(() => {
    if (isRevenueDialogOpen && selectedId) {
      const existingData = clientList.find(
        (client) => client.id === selectedId
      );
      if (existingData) {
        setValue(
          "clientName",
          `${existingData.firstname} ${existingData.lastname}`
        );
      }
    }
  }, [isRevenueDialogOpen, selectedId, setValue]);

  const onSubmit = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    try {
      const result = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/addRevenue`,
        {
          ...data,
          client_id: selectedId,
        },
        { headers }
      );
      if (
        result?.data?.response?.message === "Reveneue Added Successfully !!"
      ) {
        toast.success("Reveneue Added Successfully!");
      } else {
        toast.error("Reveneue Added Fail");
      }
      handleCloseRevenueDialog();
      reset();
    } catch (error) {
      toast.error("Failed ");
    }
  };

  const cancelHandler = () => {
    handleCloseRevenueDialog();
    reset();
  };

  return (
    <div>
      <Modal
        open={isRevenueDialogOpen}
        onClose={handleCloseRevenueDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ marginBottom: "2rem", textAlign: "center" }}
          >
            Add Revenue
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* ---------------------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                // size="small"
                sx={styles.textfield}
                id="outlined-clientName"
                label="Client Name"
                type="clientName"
                variant="outlined"
                disabled
                {...register("clientName", {
                  required: "Client Name is required",
                })}
              />
              {errors.clientName && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.clientName.message}
                </div>
              )}
            </div>

            {/* --------------------------------------------------------------------- */}
            <div style={{ margin: "25px 0px 14px 0px" }}>
              <TextField
                // size="small"
                fullWidth
                id="outlined-basic"
                label="Revenue (Rs.)"
                variant="outlined"
                {...register("revenue", {
                  required: "Revenue is required",
                  min: {
                    value: 100,
                    message: "Revenue must be at least 100",
                  },
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Invalid revenue value. Only numbers are allowed.",
                  },
                })}
              />
              {errors.revenue && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.revenue.message}
                </div>
              )}
            </div>
            {/* ----------------------------------- */}
            <div style={{ marginTop: "25px" }}>
              <TextField
                // size="small"
                sx={styles.textfield}
                id="outlined-date"
                label="Date"
                type="date"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("revenueDate", {
                  required: "date is required",
                })}
                InputProps={{
                  inputProps: {
                    placeholder: "Select Date",
                    max: new Date().toISOString().split("T")[0],
                    defaultValue: new Date().toISOString().split("T")[0],
                  },
                }}
              />
              {errors.revenueDate && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.revenueDate.message}
                </div>
              )}
            </div>
            {/* ----------------------------------- */}

            <div style={{ marginTop: "25px" }}>
              <TextareaAutosize
                aria-label="Description"
                placeholder="Description"
                minRows={3}
                style={{
                  width: "100%",
                  paddingLeft: "10px",
                  fontSize: "16px",
                  marginBottom: "2rem",
                  fontFamily: "sans-serif",
                }}
                {...register("description", {
                  required: "Description is required",
                })}
              />
              {errors.description && (
                <div
                  style={{ color: "red", fontSize: "14px", textAlign: "left" }}
                >
                  {errors.description.message}
                </div>
              )}
            </div>

            {/* --------------------------------------------------------- */}

            <Box sx={{ display: "flex ", justifyContent: "center" }}>
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 20px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  "&:hover": { background: "#002C51" },
                }}
              >
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default AddRevenueDialog;

const styles = {
  textfield: {
    width: "335px",
  },
};
